import { useState } from "react";
import constraintStyle from "../../styles/constraint.module.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import ConstraintService from "../../service/constraintService";
import { getDerivedCategoryImpact } from "../../service/categoryImpact";
import useCategoryImpact from "../../hooks/useCategoryImpact";
import StandardButton from "../UI/buttons/StandardButton";
import DeleteCategoryModal from "./DeleteCategoryModal";
import CategoryRow from "./CategoryRow";
import labels from "../../utils/labels";

const CategoriesConstraintTab = () => {
  const dispatch = useAppDispatch();
  const categories = useAppSelector(
    (state) => state.constraintSlice.categories,
  );
  const employees = useAppSelector((state) => state.constraintSlice.employees);
  const clients = useAppSelector((state) => state.constraintSlice.clients);

  const [isAdding, setIsAdding] = useState(false);
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const deletingCategory =
    categories.find((category) => category.id === deletingId) ?? null;
  const derivedImpact = deletingCategory
    ? getDerivedCategoryImpact(Number(deletingCategory.id), employees, clients)
    : { employeeCount: 0, citizenCount: 0 };
  const { impact } = useCategoryImpact(derivedImpact, deletingId);

  const handleDelete = async () => {
    if (!deletingId) return;
    try {
      await ConstraintService.deleteConcernCategory(deletingId, dispatch);
      setDeletingId(null);
    } catch {
      // error notification handled in service
    }
  };

  return (
    <div>
      <div
        className={constraintStyle.categoryTableHeaderRow}
        style={{ paddingLeft: "var(--spacing-lg)" }}
      >
        <h4>{labels.consideration}</h4>
        <h4 className={constraintStyle.actionColumn}>{labels.edit}</h4>
        <h4 className={constraintStyle.actionColumn}>{labels.delete}</h4>
      </div>

      <div>
        {categories.map((category) => (
          <CategoryRow
            key={category.id}
            category={category}
            onDelete={() => setDeletingId(category.id)}
          />
        ))}

        {isAdding ? (
          <CategoryRow onAddCancel={() => setIsAdding(false)} />
        ) : (
          <div
            style={{
              padding: "var(--spacing-sm)",
            }}
          >
            <StandardButton
              variant="TERTIARY"
              onClick={() => setIsAdding(true)}
              ariaLabel={labels.addConstraint}
            >
              {labels.addConstraint}
            </StandardButton>
          </div>
        )}
      </div>

      {deletingCategory !== null && (
        <DeleteCategoryModal
          categoryName={deletingCategory.name}
          impact={impact}
          onDelete={handleDelete}
          onDiscard={() => setDeletingId(null)}
        />
      )}
    </div>
  );
};

export default CategoriesConstraintTab;
